module.exports = __webpack_public_path__ + "img/farmer-sm.e443eae4.svg";